import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m54.6 90.6-7.3 3.9 8 4.2 7.4-3.9-8-4.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m144.5 103.3-69.3-40-69.6 40.2 69.3 39.9 69.6-40.1Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.86 6.86"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M144.3 109.6 75 69.8 5.5 109.9l69.2 39.9 69.6-40.2Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M71.7 4.4 74.9 6 77 7.2l7-7 3.2 1.6-.3 4.8 7.4-3.7 3.2 1.6-3.4 7.2 6.6.3 3.2 1.6-6.4 8 4.5 4.2-5.7 9 1.8 7.3-7.2 6.6-1.3 9.2-7.4 3.2-4.2 9.5-9.7 8.9-3-1.5-4.3-4.7-4.3 7-3.1-1.6-1.4-7.7-4.2 3.3-3-1.6 1.8-9.4-2.5-.7-3.2-1.6 4.6-9.5-3.2-5.9 6.5-7.9-.2-8.5 7.5-5 2.8-9.6 7-1.1 5.5-9.1Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m74.9 6 5.4 2.8 7-7 2.9 6.4 7.4-3.7-.2 8.8 6.6.3-3.3 9.6 4.6 4.2-5.7 9 1.8 7.3-7.2 6.5-1.4 9.3-7.4 3.1-4.2 9.6-6.4-.9-6.3 8.3-4.3-4.7-7.4 5.4-1.3-7.7-7.2 1.7 1.8-9.4-5.7-2.3L49 53l-3.3-6 6.6-7.8-.2-8.5 7.4-5 2.9-9.6 7-1.2 5.4-9Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M62.4 49v69.2l17.8-20.7 13.6 2.4.1-69.1L62.4 49Z"
    />
    <path fill="#fff" d="M70.3 44.5v54.3l8.9-13.3 6.7 4.2.1-54.3-15.6 9Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M62.3 70.5v47.7l-3.5-2V68.4l3.5 2Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m94.5 18-7-3.2c-4.1-1.8-9.5-1-15.4 3A46.1 46.1 0 0 0 52 55.6c.3 6.6 3 11 7 12.8l5 2.8c-4-1.8-.7-4.2-1-10.8a48.4 48.4 0 0 1 20.3-38c5.8-3.9 7.3-6.2 11.3-4.4Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M93.5 17.7c9.7 4.1 11 19.6 3.1 34.5-7.9 15-22 23.7-31.7 19.5-9.6-4.1-11-19.6-3.1-34.5 7.9-15 22.1-23.7 31.7-19.5Zm17.8 83.1-6.8 3.9 7.5 4.2 6.8-3.9-7.5-4.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m101 106.9-15 9.4 7.6 4.9 14.9-9.5-7.6-4.8ZM42.1 96.7 26 106l8.3 4.9 16.2-9.5-8.3-4.8Zm43 25.5-15.3 9.2"
    />
    <path
      fill="#fff"
      stroke="#FAF5EF"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M94.3 51.2a37 37 0 0 0 4.7-20c-.5-5.7-3-9.7-6.7-11.3-3.7-1.6-8.6-.9-14 2.4a41.6 41.6 0 0 0-14.2 15.9 37 37 0 0 0-4.7 20c.5 5.8 3 9.7 6.7 11.3 3.7 1.6 8.6.9 14-2.4a41.6 41.6 0 0 0 14.2-15.9Z"
    />
    <path fill="#F4EEE6" d="m80 28.4 2.7 9.2 9-5.3-7.4 12.4 2.5 10-6.9-3.9-8.4 12.6 3.2-13.5-8.4-2 10.4-7L80 28.5Z" />
  </svg>
);
